/* eslint-disable import/no-named-as-default */
import { combineReducers } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import * as actions from '@actions/auth';
import { isDevelopment } from '@rootCommon/constants/common';

import authReducer from './auth';
import brandingFilesReducer from './branding-files';
import dashboardBrandingReducer from './dashboard-branding';
import fhqBrandingReducer from './fhq-branding';
import fhqGeneralSettingsReducer from './fhq-general-settings';
import fhqHelpContactsReducer from './fhq-help-contacts';
import fhqInvitationSettingsReducer from './fhq-invitation-settings';
import fhqIpWhitelistRecordsReducer from './fhq-ip-whitelist-records';
import fhqsReducer from './fhqs';
import fhqTemplatesReducer from './fhq-templates';
import fhqUsersReducer from './fhq-users';
import glossaryReducer from './glossary';
import notificationRulesReducer from './notification-rules';
import organizationTitleReducer from './organization-title';
import organizationsItemReducer from './organizations-item';
import permissionsReducer from './permissions';
import permissionTemplatesReducer from './permission-templates';
import profileReducer from './profile';
import recoveryBinReducer from './recovery-bin';
import riskRecordReducer from './risk-record';
import securitySettingReducer from './security-setting';
import selectedOrgSiteReducer from './selected-orgId-siteId';
import sitesItemReducer from './sites-item';
import sitesListReducer from './sites-list';
import sitesSelectorReducer from './sites-selector';
import tabsAccessReducer from './tabs-access';
import userGroupReducer from './user-group';
import userGroupsReducer from './user-groups';
import usersItemReducer from './users-item';
import usersListReducer from './users-list';
import healthcheckReducer from './healthcheck';

const rootReducer = combineReducers({
  auth: authReducer,
  brandingFiles: brandingFilesReducer,
  dashboardBranding: dashboardBrandingReducer,
  fhqBranding: fhqBrandingReducer,
  fhqGeneralSettings: fhqGeneralSettingsReducer,
  fhqHelpContacts: fhqHelpContactsReducer,
  fhqInvitationSettings: fhqInvitationSettingsReducer,
  fhqIpWhitelistRecords: fhqIpWhitelistRecordsReducer,
  fhqs: fhqsReducer,
  fhqTemplates: fhqTemplatesReducer,
  fhqUsers: fhqUsersReducer,
  glossary: glossaryReducer,
  notificationRules: notificationRulesReducer,
  organizationTitle: organizationTitleReducer,
  organizationsItem: organizationsItemReducer,
  permissions: permissionsReducer,
  permissionTemplates: permissionTemplatesReducer,
  profile: profileReducer,
  recoveryBin: recoveryBinReducer,
  riskRecord: riskRecordReducer,
  securitySetting: securitySettingReducer,
  selectedOrgSite: selectedOrgSiteReducer,
  sitesItem: sitesItemReducer,
  sitesList: sitesListReducer,
  sitesSelector: sitesSelectorReducer,
  tabsAccess: tabsAccessReducer,
  userGroup: userGroupReducer,
  userGroups: userGroupsReducer,
  usersItem: usersItemReducer,
  usersList: usersListReducer,
  healthcheck: healthcheckReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const wrapRootReducer = (state: RootState | undefined, action: ActionType<typeof actions>): RootState => {
  switch (action.type) {
    case getType(actions.signOutUser):
      return rootReducer(undefined, action);
    default:
      return rootReducer(state, action);
  }
};

export default persistReducer(
  {
    key: 'finch',
    storage,
    whitelist: ['auth', 'selectedOrgSite'],
    debug: isDevelopment,
  },
  wrapRootReducer,
);
